import { desktopBaseUrl } from 'cfg/marketplace.json';

// Urls are relative in dev but absolute in prod for external consumers

export const createJsTag = (url, isNodeEnvProduction) => `<script src="${isNodeEnvProduction ? desktopBaseUrl : ''}${url}"></script>`;

export const createCssTag = (url, isNodeEnvProduction) => `<link href="${isNodeEnvProduction ? desktopBaseUrl : ''}${url}" rel="stylesheet"/>`;

export const createInlineCssTag = css => `<style>${css}</style>`;

export const createHfAssets = (webpackAssets, isNodeEnvProduction) => {
  const { assets, styles, javascript } = webpackAssets;
  let endpointScripts = '', endpointStyles = '';
  if (isNodeEnvProduction) {
    // We compile our styles differently in prod vs dev
    endpointStyles += createCssTag(styles.hfRemote, isNodeEnvProduction);
    endpointScripts += createJsTag(javascript.vendor, isNodeEnvProduction);
  } else {
    Object.keys(assets).forEach(v => {
      if (v.substr(v.length - 5) === '.scss' && assets[v]._style) {
        endpointStyles += createInlineCssTag(assets[v]._style);
      }
    });
  }

  endpointScripts += createJsTag(javascript.hfRemote, isNodeEnvProduction);

  return { endpointStyles, endpointScripts };
};

export const getSearchInputValue = (term, suggestionIndex, suggestions) => {
  if (typeof suggestionIndex === 'number' && suggestions?.length) {
    const suggestion = suggestions[suggestionIndex];
    const { categories } = suggestion;
    if (categories?.length && suggestionIndex === 0) {
      return `${suggestion.suggestion} in ${categories[0]}`;
    } else if (typeof suggestion === 'object') {
      return `${suggestion.suggestion}`;
    } else {
      return `${suggestion}`;
    }
  }
  return term;
};

export const bannerIsDynamicDataEqual = (data1, data2) => {
  if (data1.dynamicData && !data2.dynamicData ||
      !data1.dynamicData && data2.dynamicData) {
    return false;
  }

  const { link: link1 = '', text: text1 = '' } = data1.dynamicData || {};
  const { link: link2 = '', text: text2 = '' } = data2.dynamicData || {};
  return link1 === link2 && text1 === text2;
};

export const bannerIsStaticDataEqual = (data1, data2) => {
  if (data1.staticData && !data2.staticData ||
      !data1.staticData && data2.staticData) {
    return false;
  }

  const { texts: texts1 = [], gae: gae1 = '', link: link1 = '' } = data1.staticData || {};
  const { texts: texts2 = [], gae: gae2 = '', link: link2 = '' } = data2.staticData || {};
  return JSON.stringify(texts1) === JSON.stringify(texts2) && gae1 === gae2 && link1 === link2;
};

export const getTopBannerData = (props, hydraHFDynamicBanner) => {
  const { content, displayPhraseData } = props;
  return {
    // Remove this line and all references to this value when hydraHFDynamicBanner/drbn is made permanent.
    staticData: content?.Header.slotData['header-1'],
    dynamicData: hydraHFDynamicBanner && displayPhraseData
  };
};
